<template>
  <span v-if="!hideCurrency" v-bind:class="colorClass">{{ resultSum }}</span>
  <span v-else-if="hideCurrency" v-bind:class="colorClass">{{ sum }}</span>
</template>

<script>
import { getMoneyStr } from '@/lib/moneyHelpers';

export default {
  name: 'Money',
  props: ['sum', 'colorClass', 'hideCurrency'],
  data: () => ({}),
  computed: {
    resultSum() {
      return getMoneyStr(this.sum);
    },
  },
};
</script>

<style scoped lang="less">
</style>
